module.exports = {
    bindings: {
        active: '@'
    },
    templateUrl: 'correlation-table/components/correlation-table-subnav.html'
};